import { _get, _post, rootUrl } from "../../Api";
import { toast } from "react-toastify";
import {
  setAllergens,
  setArticlegroups,
  setArticles,
  setMenugroups,
  setMerchantId,
  setModifierarticles,
  setModifiergroups,
  setPrintgroups,
  setSupergroups,
  setTranslations,
  setVatOptions,
} from "./ArticlesActions";
import { Articlegroup, CreateArticlegroup } from "./models/Articlegroup";
import { Article, CreateArticle } from "./models/Article";
import { CreateModifiergroup } from "./models/Modifiergroup";
import { CreateModifierarticle } from "./models/Modifierarticle";
import articlesStore from "./ArticlesStore";
import axios from "axios";
import convertToJson from "../../helper/convertToJson";
import { CreateAllergen } from "./models/Allergen";
import { allergens as defaultAllergens } from "./../../utils/Allergens";
import { getAllergens } from "../AllergenApi";
import { CreateSupergroup } from "./models/Supergroup";

export function getArticles(merchantId) {
  getAllergens(merchantId).then((allergens) => {
    let newAllergens = { ...defaultAllergens };
    allergens.forEach((allergen) => {
      newAllergens[allergen.id] = CreateAllergen(allergen);
    });
    setAllergens(newAllergens);
  });

  _get("/nova/v2/merchant/" + merchantId + "/articlesv6")
    .then((res) => {
      setMerchantId(merchantId);
      processData(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

const processData = (data) => {
  let articlegroups = {};
  let articles = {};
  let modifiergroups = {};
  let modifierarticles = {};
  let translations = {};
  let vatOptions = {};
  let menugroups = {};
  let printgroups = {};
  let supergroups = {};

  let articleModifiergroups = {};
  let modifiergroupModifierarticles = {};

  data.m_articles.forEach((article) => {
    if (articlegroups[article.article.articlegroup_id] == null) {
      articlegroups[article.article.articlegroup_id] = new Articlegroup(
        article.article.articlegroup_id,
        article.article.articlegroup.name,
        article.article.articlegroup.handheld_bg_color,
        article.article.articlegroup.priority,
        [],
        article.article.articlegroup.translation_id,
        article.article.articlegroup.updated_at
      );

      if (!translations[article.article.articlegroup.translation_id]) {
        translations[article.article.articlegroup.translation_id] = article.article.articlegroup.translation;
      }
    }

    articlegroups[article.article.articlegroup_id].articleIds.push(article.id);
    if (vatOptions[article.vat_high] == null) {
      vatOptions[article.vat_high] = true;
    }
    if (article.tag) {
      article.tag.split("|").forEach((tag) => {
        if (!printgroups[tag]) {
          printgroups[tag] = true;
        }
      });
    }
    if (article.menu_tags) {
      article.menu_tags.split("|").forEach((tag) => {
        if (!menugroups[tag]) {
          menugroups[tag] = true;
        }
      });
    }

    articles[article.id] = CreateArticle(
      article,
      article.allergens.map((allergen) => allergen.id),
      article.m_article_m_modifiergroups.map((pivot) => pivot.m_modifiergroup_id)
    );

    if (!translations[article.translation_id]) {
      translations[article.translation_id] = article.translation;
    }
    if (!translations[article.description_translation_id]) {
      translations[article.description_translation_id] = article.description_translation;
    }

    article.m_article_m_modifiergroups.forEach((pivot) => {
      if (!articleModifiergroups[pivot.m_modifiergroup_id]) {
        articleModifiergroups[pivot.m_modifiergroup_id] = { m_article_ids: [] };
      }
      articleModifiergroups[pivot.m_modifiergroup_id].m_article_ids.push(pivot.m_article_id);
    });
  });

  data.m_modifiergroups.forEach((modifiergroup) => {
    modifiergroups[modifiergroup.id] = CreateModifiergroup(
      modifiergroup,
      modifiergroup.m_modifiergroup_m_modifierarticles.map((pivot) => pivot.m_modifierarticle_id),
      []
    );

    if (!translations[modifiergroup.translation_id]) {
      translations[modifiergroup.translation_id] = modifiergroup.translation;
    }

    modifiergroup.m_modifiergroup_m_modifierarticles.forEach((pivot) => {
      if (!modifiergroupModifierarticles[pivot.m_modifierarticle_id]) {
        modifiergroupModifierarticles[pivot.m_modifierarticle_id] = { m_modifiergroup_ids: [] };
      }
      modifiergroupModifierarticles[pivot.m_modifierarticle_id].m_modifiergroup_ids.push(pivot.m_modifiergroup_id);
    });
  });

  Object.keys(modifiergroups).forEach((modifiergroupId) => {
    if (articleModifiergroups[modifiergroupId]) {
      modifiergroups[modifiergroupId].articleIds = articleModifiergroups[modifiergroupId].m_article_ids;
    }
  });

  data.m_modifierarticles.forEach((modifierarticle) => {
    modifierarticles[modifierarticle.id] = CreateModifierarticle(modifierarticle, []);

    if (!translations[modifierarticle.translation_id]) {
      translations[modifierarticle.translation_id] = modifierarticle.translation;
    }
  });

  Object.keys(modifierarticles).forEach((modifierarticleId) => {
    if (modifiergroupModifierarticles[modifierarticleId]) {
      modifierarticles[modifierarticleId].modifiergroupIds =
        modifiergroupModifierarticles[modifierarticleId].m_modifiergroup_ids;
    }
  });

  data.supergroups.forEach((supergroup) => {
    supergroups[supergroup.id] = CreateSupergroup(supergroup);
  });

  setTranslations(translations);
  setArticles(articles);
  setArticlegroups(articlegroups);
  setModifierarticles(modifierarticles);
  setModifiergroups(modifiergroups);
  setVatOptions(vatOptions);
  setMenugroups(menugroups);
  setPrintgroups(printgroups);
  setSupergroups(supergroups);
};

export function createArticles(merchantId, articles) {
  const articlesJSON = articles.map((article) => convertToJson(article));

  _post("/nova/v2/merchant/" + merchantId + "/articles", articlesJSON)
    .catch((err) =>
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    )
    .then((res) => {
      let newArticles = { ...articlesStore.articles };
      let newArticlegroups = { ...articlesStore.articlegroups };
      let newModifiergroups = { ...articlesStore.modifiergroups };

      res.data.forEach((article) => {
        const newArticle = CreateArticle(
          article,
          article.allergens.map((a) => a.id),
          article.m_modifiergroups.map((m) => m.id)
        );
        newArticles[newArticle.id] = newArticle;

        article.m_modifiergroups.forEach((modifiergroup) => {
          if (!newModifiergroups[modifiergroup.id].articleIds.includes(newArticle.id)) {
            newModifiergroups[modifiergroup.id].articleIds.push(newArticle.id);
          }
        });

        if (!newArticlegroups[newArticle.articlegroup_id]) {
          const newArticlegroup = CreateArticlegroup(article.article.articlegroup, [newArticle.id]);
          newArticlegroups[newArticlegroup.id] = newArticlegroup;
        } else {
          if (!newArticlegroups[newArticle.articlegroup_id].articleIds.includes(newArticle.id)) {
            newArticlegroups[newArticle.articlegroup_id].articleIds.push(newArticle.id);

            /// TODO remove from old articlegroup
          }
        }
      });

      //delete newArticlegroup in store to prevent duplicates
      articlesJSON.map((article) => {
        if (isNaN(article.articlegroup_id)) {
          delete newArticlegroups[article.articlegroup_id];
        }
      });
      setModifiergroups(newModifiergroups);
      setArticles(newArticles);
      setArticlegroups(newArticlegroups);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function updateArticle(merchantId, article, newData, updatedKey = true) {
  return updateArticles(merchantId, [article], [newData], null, updatedKey).then((articles) => {
    return Promise.resolve(articles[0]);
  });
}

export function updateArticles(merchantId, articles, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in articles) {
    data.push({
      articleId: articles[i].id,
      ...newData[i],
    });
  }

  return _post("/nova/v2/merchant/" + merchantId + "/articles", data)
    .catch((e) => {
      let newArticles = { ...articlesStore.articles };
      articles.forEach((article, i) => {
        newArticles[article.id] = Object.assign(new Article(), article);
        Object.keys(data[i]).forEach((key) => {
          newArticles[article.id][key] = oldValues[i][key];
        });
        newArticles[article.id].updatedAt = new Date().toLocaleString();
      });
      setArticles(newArticles);
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      let updatedArticles = [];
      let newArticles = { ...articlesStore.articles };
      let newArticlegroups = { ...articlesStore.articlegroups };
      let newModifiergroups = { ...articlesStore.modifiergroups };
      let newSupergroups = { ...articlesStore.supergroups };

      res.data.forEach((article) => {
        const oldArticle = articlesStore.articles[article.id];

        if (article.deleted_at === null) {
          const newArticle = CreateArticle(
            article,
            article.allergens.map((a) => a.id),
            article.m_modifiergroups.map((m) => m.id)
          );
          newArticles[newArticle.id] = newArticle;

          article.m_modifiergroups.forEach((modifiergroup) => {
            if (!newModifiergroups[modifiergroup.id].articleIds.includes(newArticle.id)) {
              newModifiergroups[modifiergroup.id].articleIds.push(newArticle.id);
            }
          });
          oldArticle.modifiergroupIds.forEach((modifiergroupId) => {
            let index = newArticle.modifiergroupIds.indexOf(modifiergroupId);
            if (index === -1) {
              let articleIndex = newModifiergroups[modifiergroupId].articleIds.indexOf(newArticle.id);
              newModifiergroups[modifiergroupId].articleIds.splice(articleIndex, 1);
            }
          });

          if (!newArticlegroups[newArticle.articlegroup_id]) {
            const newArticlegroup = CreateArticlegroup(article.article.articlegroup, [newArticle.id]);
            newArticlegroups[newArticlegroup.id] = newArticlegroup;
            if (isNaN(oldArticle.articlegroup_id)) {
              delete newArticlegroups[oldArticle.articlegroup_id];
            }
          } else {
            if (!newArticlegroups[newArticle.articlegroup_id].articleIds.includes(newArticle.id)) {
              newArticlegroups[newArticle.articlegroup_id].articleIds.push(newArticle.id);
            }
          }
          updatedArticles.push(newArticle);
        } else {
          let oldArticle = newArticles[article.id];
          const index = newArticlegroups[oldArticle.articlegroup_id].articleIds.indexOf(oldArticle.id);
          if (index > -1) {
            newArticlegroups[oldArticle.articlegroup_id].articleIds.splice(index, 1);
          }
          oldArticle.modifiergroupIds.forEach((modifiergroupId) => {
            let index = newModifiergroups[modifiergroupId].articleIds.indexOf(oldArticle.id);
            if (index > -1) {
              newModifiergroups[modifiergroupId].articleIds.splice(index, 1);
            }
          });
          delete newArticles[article.id];
        }
      });

      setArticlegroups(newArticlegroups);
      setArticles(newArticles);
      setModifiergroups(newModifiergroups);
      setSupergroups(newSupergroups);

      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(updatedArticles);
    });
}

export function updateArticlesTranslations(merchantId, articles, newData, oldValues, description) {
  let data = [];
  for (let i in articles) {
    data.push({
      articleId: articles[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/articles", data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      let newTranslations = { ...articlesStore.translations };
      let newArticles = { ...articlesStore.articles };

      res.data.forEach((article) => {
        if (article.translation) {
          const newTranslation = article.translation;
          newTranslations[newTranslation.id] = newTranslation;
          if (newArticles[article.id].translation_id !== newTranslation.id) {
            let newArticle = CreateArticle(
              article,
              article.allergens.map((a) => a.id),
              article.m_modifiergroups.map((modifiergroup) => modifiergroup.id)
            );
            newArticles[newArticle.id] = newArticle;
          }
        }
        if (article.description_translation) {
          const newTranslation = article.description_translation;
          newTranslations[newTranslation.id] = newTranslation;
          if (newArticles[article.id].description_translation_id !== newTranslation.id) {
            let newArticle = CreateArticle(
              article,
              article.allergens.map((a) => a.id),
              article.m_modifiergroups.map((modifiergroup) => modifiergroup.id)
            );
            newArticles[newArticle.id] = newArticle;
          }
        }
      });

      setArticles(newArticles);
      setTranslations(newTranslations);

      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function updateArticlegroups(merchantId, articlegroups, key, values) {
  let data = [];
  for (let i in articlegroups) {
    data.push({
      articlegroupId: articlegroups[i].id,
      [key]: values[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/articlegroups", data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      let newArticlegroups = { ...articlesStore.articlegroups };
      res.data.forEach((articlegroup, index) => {
        newArticlegroups[articlegroup.id] = CreateArticlegroup(
          articlegroup,
          newArticlegroups[articlegroup.id].articleIds
        );
      });
      setArticlegroups(newArticlegroups);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function updateArticlegroupsTranslations(merchantId, articlegroups, newData, oldValues) {
  let data = [];
  for (let i in articlegroups) {
    data.push({
      articlegroupId: articlegroups[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/articlegroups", data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      const newTranslations = { ...articlesStore.translations };
      const newArticlegroups = { ...articlesStore.articlegroups };

      res.data.forEach((articlegroup) => {
        const newTranslation = articlegroup.translation;
        newTranslations[newTranslation.id] = newTranslation;

        if (newArticlegroups[articlegroup.id].translation_id !== newTranslation.id) {
          newArticlegroups[articlegroup.id] = CreateArticlegroup(
            articlegroup,
            newArticlegroups[articlegroup.id].articleIds
          );
        }
      });
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function uploadArticleImage(merchantId, articleId, image) {
  let bodyFormData = new FormData();
  bodyFormData.set("merchantId", merchantId);
  bodyFormData.set("image", image);
  return axios
    .post(rootUrl + "/nova/merchant/" + merchantId + "/article/" + articleId + "/image", bodyFormData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      let newArticles = { ...articlesStore.articles };
      newArticles[articleId] = Object.assign(new Article(), newArticles[articleId]);
      newArticles[articleId].image = response.data;
      newArticles[articleId].updatedAt = new Date().toLocaleString();
      setArticles(newArticles);
      toast.success("Opgeslagen!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(response.data);
    })
    .catch((e) => {
      console.log(e);
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}
